import { RouterModule } from '@angular/router';
import { Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import {DataTableModule} from "angular2-datatable";

import { AppComponent } from './app.component';
import { SelectClientComponent } from './select-client/select-client.component';
import { ActiveShipmentsComponent } from './active-shipments/active-shipments.component';
import { CreateBolComponent } from './create-bol/create-bol.component';
import { WithPodComponent } from './with-pod/with-pod.component';
import { AddressesService } from './services/addresses.service';
import { ClientsService } from './services/clients.service';
import { ShipmentsService } from './services/shipments.service';
import { InvoiceViewComponent } from './invoice-view/invoice-view.component';
import { EditShipmentComponent } from './edit-shipment/edit-shipment.component';
import { CreateAddressComponent } from './create-address/create-address.component';
import { PrintShipmentComponent } from './print-shipment/print-shipment.component';
import { SigninComponent } from './signin/signin.component';
import { AuthService } from './services/auth.service';
import { RbacAllowDirective } from './rbac-allow.directive';
import { AdminComponent } from './admin/admin.component';
import { ManagerComponent } from './manager/manager.component';
import { AdvancedBolComponent } from './advanced-bol/advanced-bol.component';
import { AddresseditComponent } from './addressedit/addressedit.component';
import { QbComponent } from './qb/qb.component';
import { UsersComponent } from './users/users.component';
import { PortalShipmentComponent } from './portal-shipment/portal-shipment.component';
import { PalletComponent } from './pallet/pallet.component';
import { PalletService } from './services/pallet.service';
import { QueryService } from './services/query.service';
import { PrintPltshipmentComponent } from './print-pltshipment/print-pltshipment.component';
import { CreateBol2Component } from './create-bol2/create-bol2.component';

const appRoutes: Routes = [

  {path: '', component: ActiveShipmentsComponent},
  {path: 'signin', component: SigninComponent},
  {path: 'selectclient', component: SelectClientComponent},
  {path: 'activeshipments', component: ActiveShipmentsComponent},
  {path: 'portalbol', component: PortalShipmentComponent},
  {path: 'createbol', component: CreateBolComponent},
  {path: 'createbol2', component: CreateBol2Component},
  {path: 'invwithpod', component: InvoiceViewComponent},
  {path: 'editbol/:bol', component: EditShipmentComponent},
  {path: 'printbol/:bol', component: PrintShipmentComponent},
  {path: 'printbolplt/:bol', component: PrintPltshipmentComponent},
  {path: 'withpod', component: WithPodComponent},
  {path: 'pallet', component: PalletComponent},
  {path: 'admin', component: AdminComponent},
  {path: 'manager', component: ManagerComponent, children:[
    {path: 'advancedboledit', component: AdvancedBolComponent },
    {path: 'addressedit', component: AddresseditComponent },
    {path: 'qb', component: QbComponent },
    {path: 'users', component: UsersComponent }
  ]},
  {path: 'createaddress/:clientid', component: CreateAddressComponent}


];


@NgModule({
  declarations: [
    AppComponent,
    SelectClientComponent,
    ActiveShipmentsComponent,
    CreateBolComponent,
    WithPodComponent,
    InvoiceViewComponent,
    EditShipmentComponent,
    CreateAddressComponent,
    PrintShipmentComponent,
    SigninComponent,
    RbacAllowDirective,
    AdminComponent,
    ManagerComponent,
    AdvancedBolComponent,
    AddresseditComponent,
    QbComponent,
    UsersComponent,
    PortalShipmentComponent,
    PalletComponent,
    PrintPltshipmentComponent,
    CreateBol2Component
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    BrowserAnimationsModule ,
    DataTableModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [ClientsService, ShipmentsService, AddressesService, AuthService, PalletService, QueryService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts